<script lang="ts">
  import RichText from '$components/rich-text.svelte';
  import Icon, { isIconVariant } from '$components/ui/icon/icon.svelte';
  import { cn } from '$lib/utils';
  import type { ProductInfoCardStoryblok } from '$types/bloks';

  export let productInfoCard: ProductInfoCardStoryblok[] | undefined;
</script>

{#if productInfoCard && productInfoCard.length > 0}
  <div
    class={cn(
      'rounded-md mt-6',
      productInfoCard[0].hide_mobile && 'hidden lg:block',
      productInfoCard[0].hide_desktop && 'lg:hidden'
    )}
  >
    <h3 class="text-lg font-medium">{productInfoCard[0].title}</h3>
    <div class="flex flex-col gap-2 mt-4">
      {#each productInfoCard[0].infos as info}
        {@const icon = info.icon?.toString()}
        <div class="bg-highlight rounded-sm p-3">
          <div class="flex gap-2 mb-4 items-center">
            {#if icon && isIconVariant(icon)}
              <Icon size="sm" {icon} class="block h-fit shrink-0" />
            {/if}
            <h4 class="text-sm font-semibold">{info.title}</h4>
          </div>

          <div>
            <RichText
              doc={info.content}
              class={cn(
                '[&>p]:text-sm',
                '[&>p]:opacity-70',
                '[&>p]:!leading-[120%]',
                '[&>*+p]:mt-1',
                '[&>p>img]:mt-3 [&>p>img]:w-full [&>p>img]:rounded-xs [&>p>img]:border [&>p>img]:border-primary/4 [&>p>img]:object-contain',
                '[&>*+.rich-text-button-cta]:mt-3',
                '[&>*+.rich-text-metrics]:mt-5',
                '[&>.rich-text-metrics+p]:mt-5'
              )}
            />
          </div>
        </div>
      {/each}
    </div>
  </div>
{/if}
